import React        from 'react'

const StatRow = ({
  stat = {
    homeValue : '-',
    text :    '-',
    awayValue : '-'
  }
}) => {
  return (
    <tr>
      <td className="score" colSpan="2">{stat.homeValue}</td>
      <td className="label" colSpan="2">{stat.text}</td>
      <td className="score" colSpan="2">{stat.awayValue}</td>
    </tr>
  )
}

const StatsTable = ({
  stats = []
}) => { 
  const iLen  = stats.length || 0
  let aRows   = []
  
  for ( let i = 0, l = iLen; i < l; i++ ) {
    aRows.push(<StatRow key={i} stat={stats[i]} />)
  }
  
  return (
    <table className="compareTable">
      <tbody>
        {aRows}
      </tbody>
    </table> 
  )
}

export default StatsTable



// WEBPACK FOOTER //
// ../app/components/gamepackage/rugby/components/statistics/StatsTable.jsx